import { useTranslation } from 'react-i18next';

import type { RunStreamStatus } from '../../hooks/use-delivery-run-stream';

import { DeliveryStatusChip } from './delivery-status-chip';

/**
 * Tells the operator how the run view is being kept fresh: `live` = SSE
 * connected (pulsing), `connecting` = opening/reconnecting, `fallback` = the
 * stream gave up and the 4s poll is in charge. Renders nothing when idle
 * (terminal run or stream disabled).
 */
export function LiveIndicator({ status }: { status: RunStreamStatus }) {
  const { t } = useTranslation('deliveries');
  if (status === 'idle') return null;
  if (status === 'live') {
    return (
      <DeliveryStatusChip
        tone="success"
        label={t('stream.live')}
        pulse
        testId="delivery-live-indicator-live"
      />
    );
  }
  if (status === 'connecting') {
    return (
      <DeliveryStatusChip
        tone="muted"
        label={t('stream.connecting')}
        testId="delivery-live-indicator-connecting"
      />
    );
  }
  return (
    <DeliveryStatusChip
      tone="muted"
      label={t('stream.polling')}
      testId="delivery-live-indicator-polling"
    />
  );
}
